import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gSteps from "@/components/g-steps/g-steps.vue"
import gMenuSidebar from "@/components/g-menu-sidebar/g-menu-sidebar.vue"
import gCardResumo from "@/components/g-card-resumo/g-card-resumo.vue"
import CartaPropostaController from "@/shared/controllers/cartaProposta/CartaPropostaController";



export default {
  name:'GerarCartaProposta',
  components:{
    'g-card': gCard,
    'g-form': gForm,
    'g-button': gButton,
    'g-steps': gSteps,
    'g-menu-sidebar': gMenuSidebar,
    'g-card-resumo': gCardResumo
  },
  data () {
    return {
      OrcamentoArrayQuantidade: 0,
      CartaPropostaId: null,
      steps: 0,
      lateral: false,
      step1: {},
      step2: {},
      items: [
        {
          label: 'orcamentos',
          icon: "pi pi-check",
          to: `/gerar-carta-proposta/${this.$route.params.id}/orcamento`,
        },
        {
          label: 'pagamento',
          icon: "pi pi-money-bill",
          to: `/gerar-carta-proposta/${this.$route.params.id}/pagamento`,
        },
        {
          label: 'markup',
          icon: "pi pi-chart-line",
          to: `/gerar-carta-proposta/${this.$route.params.id}/markup`
        }
        
      ]
    }
  },

  methods: {
    GetCartaPropostaResumoLateralStep1() {
      this.CartaPropostaId = this.$route.params.id
      CartaPropostaController.GetCartaPropostaResumoLateralStep1(this.CartaPropostaId).requisicao
      .then((response) => {
      this.step1 = response.data.data
      })
    },
    GetCartaPropostaResumoLateralStep2() {
      this.CartaPropostaId = this.$route.params.id
      CartaPropostaController.GetCartaPropostaResumoLateralStep2(this.CartaPropostaId).requisicao
      .then((response) => {
      this.step2 = response.data.data
      this.OrcamentoArrayQuantidade = this.step2.length
      })
    },
    GetCartaPropostaResumoLateralStep3() {
      this.CartaPropostaId = this.$route.params.id
      CartaPropostaController.GetCartaPropostaResumoLateralStep3(this.CartaPropostaId).requisicao
      .then((response) => {
      this.step3 = response.data.data
      })
    },
    verificarTabs (index) {

      this.steps = index
      if (index >= 0 ) {
        this.GetCartaPropostaResumoLateralStep1()
      }
      if (index >= 1) {
        this.GetCartaPropostaResumoLateralStep2()
      }
      if (index >= 2) {
        this.GetCartaPropostaResumoLateralStep3()
      }
    },
   ativar (){
    this.lateral = true
   }
  }
}